module.exports = __webpack_public_path__ + "images/柏纳长图_04-1 .jpg?v=eeb0af41";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_04-1 .jpg
 ** module id = 139
 ** module chunks = 1 2
 **/